<template>
  <div class="container">
    <v-card>
      <v-card-title>
         <router-link :to="{ name: 'jschemas_add'}">
            <v-icon small  class="mr-2"> add </v-icon>
          </router-link>      <v-spacer></v-spacer>
          <div class="my-2">
            <v-btn small color="primary" @click="getList()">update list</v-btn>
          </div>
      </v-card-title>
      <v-data-table
        dense
        :loading="isLoading"
        :headers="headers"
        :items="list"
        :options.sync="pagination"
        :rowsPerPageItems="rowsPerPageItems"
        class="elevation-1"
        item-key="id"
      >
         <template v-slot:item="props">
          <tr>
            <td class="justify-center">
              <router-link :to="{ name: 'jschemas_edit', params: { id: props.item.id }}">
                <v-icon small  class="mr-2"> edit </v-icon>
              </router-link>
              <v-icon small @click="deleteItem(props.item.id)" class="mr-2"> delete </v-icon>
            </td>
            <template v-for="(value, key) in props.item">
              <td v-if="key !== 'schema' && key !== 'template'" 
                :key="key" class="text-xs-right"> 
                {{ value }}
              </td>
            </template>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>


<script>
  export default {
    data () {
      return {
        list: [],
        rowsPerPageItems: [10, 20, 40, 80 ,160, {"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}],
        pagination: {
            rowsPerPage: 10,
        },
        isLoading: false,
      }
    },
    mounted() {
      this.getList();
    },
    computed: {
      headers() {
        const headers = [];

        headers.push({
          text: 'Actions',
          value: 'name',
          sortable: false
        });

        if (this.list[0]) {
          Object.keys(this.list[0]).forEach((key) => {
            if (key === 'schema' || key === 'template') {
              return;
            }

            headers.push({
              text: key,
              value: key,
              align: 'left'
            });
          });
        }

        return headers;
      }
    },
    methods: {
      async getList() {
        this.isLoading = true;
        
        const response = await this.$api.jschemas.getList();
        const listResponse = await response.data;
        const list = [];

        Object.keys(listResponse).forEach((key) => {
          listResponse[key].id = key;
          list.push(listResponse[key]);
        });

        this.list = list;

        this.isLoading = false;
      },
      async deleteItem(id) {
        this.isLoading = true;

        const response = await this.$api.jschemas.delete(id);
        
        if (response.status == 200) {
          this.list = this.list.filter((item) => item.id !== id);
        }

        this.isLoading = false;
      }
    },
}
</script>

<style>

table.v-table tbody td:first-child, table.v-table tbody td:not(:first-child), table.v-table tbody th:first-child, table.v-table tbody th:not(:first-child), table.v-table thead td:first-child, table.v-table thead td:not(:first-child), table.v-table thead th:first-child, table.v-table thead th:not(:first-child) {
    padding: 0px;
}
table.v-table tbody td, table.v-table tbody th {
    height: 0px;
}
</style>



// WEBPACK FOOTER //
// src/pages/jschemas/list.vue